// extracted by mini-css-extract-plugin
module.exports = {"container":"WlmuLUEsCDaSsle46-A0nQ==","item":"I4-Q4EBx4yrDfGLfOw0vwQ==","text":"jYrJuYsk7I1edHXHx3kXlw=="};